import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockVideo from "../../Block/BlockVideo";

function ColorTransferLab() {
    return (
        <div>
        <Header/>        

        <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                    height:"200px",
                    width: "100%",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "bottom"}}>
        </div>

        <Block colorTheme="light" gridTemplateColumns="600px 600px">
            <BlockContent>
            <BlockTitle>ColorTransferLab</BlockTitle>
            </BlockContent>
            <BlockContent>
            <BlockText>ColorTransferLab is a web-based application designed to simplify and standardize the application and evaluation of diverse Color and Style Transfer Algorithms, which have been developed and refined over the past two decades in the field of digital image processing. This platform empowers users with a user-friendly interface to explore and apply these algorithms with ease.</BlockText>
            </BlockContent>
        </Block>


        <Block gridTemplateColumns="600px 600px">
            <BlockContent>
            <BlockSubtitle>Details</BlockSubtitle>
            <BlockText>
                <ul>
                    <li>Web-based platform designed for user-friendly application of color and style transfer as well as colorization algorithms across diverse data types.</li>
                    <li>Supported data types: images, textured meshes, point clouds, light fields, videos, gaussian splattings, volumetric videos.</li>
                    <li>Supports complete self-hosting.</li>
                    <li>Support for 11 color transfer, 5 style transfer and 3 colorization algorithms, configurable directly through the web interface.</li>
                    <li>Incorporation of multiple objective evaluation metrics for comprehensive analysis.</li>
                </ul>
            </BlockText>
            </BlockContent>
            <BlockContent>
                <BlockImage src={process.env.PUBLIC_URL + '/images/projects/ColorTransferLab2.webp'} title="Figure 1: ColorTransferLab Interface"/>
            </BlockContent>
        </Block>
        
        <Block gridTemplateColumns="600px 600px">
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/ColorTransferLabMin.mp4" title="Video 1: Demonstration ColorTransferLab"/>
            </BlockContent>
            <BlockContent>
                <BlockVideo src="https://potechius.com/Videos/ColorTransferLabUserStudy.mp4" title="Video 2: Demonstration ColorTransferLab User Study"/>
            </BlockContent>
        </Block>

        <Block colorTheme="light" gridTemplateColumns="400px 400px 400px"> 
            <BlockContent textAlign="center" color="grey" fontStyle="italic">
            <BlockButton width="190px" onClick={() => window.open("https://potechius.com/ColorTransferLab/LandingPage")}>ColorTransferLab</BlockButton>
            </BlockContent>
            <BlockContent textAlign="center" color="grey" fontStyle="italic">
            <BlockButton width="190px" onClick={() => window.open("https://github.com/ImmersiveMediaLaboratory/ColorTransferLab")}>
                <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/images/base/github.webp'} alt=""/> ColorTransferLab
            </BlockButton>
            </BlockContent>
            <BlockContent textAlign="center" color="grey" fontStyle="italic">
            <BlockButton width="190px" onClick={() => window.open("https://github.com/ImmersiveMediaLaboratory/ColorTransferLib")}>
            <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/images/base/github.webp'} alt=""/> ColorTransferLib</BlockButton>
            </BlockContent>
        </Block>




        
        <Footer/>
        </div>
    );
}

export default ColorTransferLab;